import FreezeCard from './FreezeCard';

export default FreezeCard;
